function init(name) {
    var re = new RegExp(name + "=([^;]+)");
    var value = re.exec( document.cookie );
    
    // value != null ? console.log('cookieGet | ' + name + ': ' + unescape(value[1]) ) : null;
    return value != null ? unescape(value[1]) : null;
}

module.exports = { init };